import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, NotificationType, Notification } from 'edenred-ui';

const WarningProcessingOfEmployees = ({ isHidden }: { isHidden?: boolean }) => {
  const { t } = useTranslation();

  if (isHidden) {
    return null;
  }

  return (
    <Box>
      <Notification
        text={t('containers.benefit_groups.processing_of_employees.warning')}
        id={'processing-of-employees-warning'}
        type={NotificationType.Important}
      />
    </Box>
  );
};

export { WarningProcessingOfEmployees };
